module.exports = __webpack_public_path__ + "img/sharexsalo.5be9bf58.svg";